import React from "react"
import Navbar from "../../../../Common/Components/Navbar"
import Footer from "../../../../Common/Components/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import MySlotsComp  from "./Component/MySlotsComp"

const MySlots =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <MySlotsComp />
        </div>
        <Footer />
        </>
    )
}

export default MySlots